import { useCallback, useState } from 'react';
import { agentNameValueStore } from '../utils/agentNameValueStore';

export const useChatAgentName = () => {
    const [agentName, setAgentName] = useState();

    const setAgentNameWrapper = useCallback(agentNameValue => {
        agentNameValueStore.setValue(agentNameValue);
        setAgentName(agentNameValue);
    }, []);
    const unsetAgentNameWrapper = useCallback(() => {
        agentNameValueStore.setValue();
        setAgentName();
    }, []);

    return [agentName, setAgentNameWrapper, unsetAgentNameWrapper];
};
